var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewsDecor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 853,
    height: 1708,
    viewBox: "0 0 853 1708",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.00011 2.00057C-471.547 2.00055 -853 383.454 -853 854.001C-853 1324.55 -471.547 1706 -1.00018 1706C469.547 1706 851 1324.55 851 854.001C851 383.454 469.547 2.00059 -1.00011 2.00057ZM-1.00011 0.000573022C-472.651 0.000552405 -855 382.349 -855 854.001C-855 1325.65 -472.651 1708 -1.00018 1708C470.651 1708 853 1325.65 853 854.001C853 382.349 470.651 0.000593639 -1.00011 0.000573022ZM-0.999263 204.987C-359.44 204.987 -650.014 495.561 -650.014 854.002C-650.014 1212.44 -359.44 1503.02 -0.99932 1503.02C357.442 1503.02 648.016 1212.44 648.016 854.002C648.016 495.561 357.442 204.987 -0.999263 204.987ZM-0.999263 202.987C-360.545 202.987 -652.014 494.456 -652.014 854.002C-652.014 1213.55 -360.545 1505.02 -0.99932 1505.02C358.546 1505.02 650.016 1213.55 650.016 854.002C650.016 494.456 358.546 202.987 -0.999263 202.987ZM-483.604 854.001C-483.604 587.466 -267.535 371.397 -1.00019 371.397C265.534 371.397 481.604 587.466 481.604 854.001C481.604 1120.54 265.534 1336.6 -1.00023 1336.6C-267.535 1336.6 -483.604 1120.54 -483.604 854.001ZM-485.604 854.001C-485.604 586.361 -268.64 369.397 -1.00019 369.397C266.639 369.397 483.604 586.361 483.604 854.001C483.604 1121.64 266.639 1338.6 -1.00023 1338.6C-268.64 1338.6 -485.604 1121.64 -485.604 854.001ZM-0.999948 523.179C-183.708 523.179 -331.822 671.293 -331.822 854.001C-331.822 1036.71 -183.708 1184.82 -0.999977 1184.82C181.708 1184.82 329.822 1036.71 329.822 854.001C329.822 671.293 181.708 523.179 -0.999948 523.179ZM-0.999948 521.179C-184.813 521.179 -333.822 670.188 -333.822 854.001C-333.822 1037.81 -184.813 1186.82 -0.999977 1186.82C182.813 1186.82 331.822 1037.81 331.822 854.001C331.822 670.188 182.813 521.179 -0.999948 521.179Z",
    fill: "url(#paint0_radial_409_903)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_409_903",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(277.5 854.001) rotate(-180) scale(642.283 1227.38)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsDecor);
export default __webpack_public_path__ + "static/media/NewsDecor.fbb2fc36388b9ad3b14f4e6970b574ee.svg";
export { ForwardRef as ReactComponent };